import { CLOSE_MODAL, DRAW_MODAL, REMOVE_MODAL, SHOW_MODAL } from './types';
const initialState = {
  modalType: undefined,
  modalProps: {},
  isOpen: false
};
export const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case DRAW_MODAL:
      if (!action.modal) {
        return state;
      }
      return {
        ...state,
        modalType: action.modal,
        modalProps: action.props || {}
      };
    case REMOVE_MODAL:
      return {
        ...state,
        modalType: undefined,
        modalProps: {}
      };
    case SHOW_MODAL:
      return {
        ...state,
        isOpen: true,
        modalProps: action.modalProps
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false
      };
    default:
      return state;
  }
};